module.exports = __webpack_public_path__ + "img/seattle-1.4460c2d1.jpg";